<template>
  <div>
    <div v-if="lineToBar" class="padding8">
      <label class="font14 inlineMiddle mr8">数据样式</label>
      <el-select v-model="labelType" class="percent65_ height32" ref="" @change="typeChange">
        <el-option
          v-for="(item, index) in labelStyleList"
          :key="index"
          :selected="labelType == item.value"
          :value="item.value"
          :label="item.title"
          >{{ item.title }}
        </el-option>
      </el-select>
    </div>
    <collapsibleItem>
      <div slot="heading">形状设置</div>
      <div slot="body" class="mt8">
        <div class="data-item">
          <cx-select title="折线样式" :selectOptions="lineType" :value.sync="smooth" />
        </div>
        <div class="mb16 mt16">
          <div>
            <el-radio-group v-model="lineColorType.type" @change="changeLineColorQuantity(lineColorType.type)">
              <el-radio label="纯色">纯色</el-radio>
              <el-radio label="线性渐变">线性渐变</el-radio>
            </el-radio-group>
          </div>
          <div v-if="lineColorType.type === '纯色'">
            <color-picker :color.sync="lineColorType.color" titlePosition="singleLine" />
          </div>
          <div v-if="lineColorType.type !== '纯色'" class="mt12">
            <color-picker title="开始颜色" :color.sync="lineColorType.startColor" titlePosition="singleLine" />
          </div>
          <div v-if="lineColorType.type !== '纯色'" class="mt8">
            <color-picker
              class="mt8"
              title="结束颜色"
              :color.sync="lineColorType.endColor"
              titlePosition="singleLine"
            />
          </div>
        </div>
        <div class="data-item mt16">
          <line-setting
            title="线条"
            :lineName.sync="lineStyleType"
            :lineWidth.sync="lineStyleWidth"
            :themeKey="request_prefix"
          />
        </div>
        <div class="data-item mt16">
          <div class="mb16">
            <cx-check-box :value.sync="showAreaStyle" @change="changeShowAreaStyleHandle()">显示面积</cx-check-box>
          </div>
          <div v-show="showAreaStyle">
            <div>
              <el-radio-group v-model="areaColorType.type" @change="changeAreaColorQuantity(areaColorType.type)">
                <el-radio label="纯色">纯色</el-radio>
                <el-radio label="线性渐变">线性渐变</el-radio>
              </el-radio-group>
            </div>
            <div v-if="areaColorType.type === '纯色'">
              <color-picker :color.sync="areaColorType.color" titlePosition="singleLine" />
            </div>
            <div v-if="areaColorType.type !== '纯色'" class="mt16">
              <color-picker
                class="mt16"
                title="开始颜色"
                :color.sync="areaColorType.startColor"
                titlePosition="singleLine"
              />
            </div>
            <div v-if="areaColorType.type !== '纯色'" class="mt16 mb8">
              <color-picker
                class="mt16"
                title="结束颜色"
                :color.sync="areaColorType.endColor"
                titlePosition="singleLine"
              />
            </div>
          </div>
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">节点设置</div>
      <div slot="body" class="mt8">
        <div class="data-item">
          <cx-select title="节点形状" :selectOptions="symbolTypeList" :value.sync="symbolData" />
        </div>
        <div class="data-item mt16" v-if="symbolData === 'image'">
          <img-upload-simple :imgSrc.sync="symbolImage" />
        </div>
        <!--节点-->
        <div class="mt16">
          <p class="font14 mb8">节点大小</p>
          <slider-and-input :value.sync="symbolSize" title="" titlePosition="singleLine" :sliderMax="100" suffix="px" />
        </div>
      </div>
    </collapsibleItem>
    <collapsibleItem>
      <div slot="heading">文本设置</div>
      <div slot="body" class="mt8 mb8">
        <el-checkbox v-model="showLabel">显示文本</el-checkbox>
        <div class="mt16" v-if="showLabel && checkType(showLabel)">
          <text-setting-update
            class="mb16"
            :fontColor.sync="labelFontColor"
            :fontFamily.sync="labelFontFamily"
            :fontSize.sync="labelFontSize"
            :fontWeight.sync="labelFontWeight"
            colorMode="chart"
          />
          <div class="mt16" v-if="checkType(showLabelUnit)">
            <cx-check-box :value.sync="showLabelUnit">显示单位</cx-check-box>
            <div class="mt16" v-if="showLabelUnit">
              <span class="font14 mr10 half-label">单位文本</span>
              <el-input
                class="width-half-bigWidth el-input el-input--suffix"
                placeholder="请输入"
                v-model="showLabelUnitValue"
              >
              </el-input>
            </div>
            <!-- 字体和颜色 -->
            <!--字重和字号 -->
            <text-setting-update
              v-if="
                showLabelUnit &&
                labelUnitValueFontWeight &&
                labelUnitValueFontColor &&
                labelUnitValueFontFamily &&
                labelUnitValueFontSize
              "
              class="mt16"
              :fontColor.sync="labelUnitValueFontColor"
              :fontFamily.sync="labelUnitValueFontFamily"
              :fontSize.sync="labelUnitValueFontSize"
              :fontWeight.sync="labelUnitValueFontWeight"
              colorMode="chart"
            />
          </div>
        </div>
      </div>
    </collapsibleItem>
  </div>
</template>

<script>
import publicData from "../publicData"
export default {
  mixins: [publicData],
  props: {
    seriesSettingItem: {
      type: Object
    },
    index: {
      type: Number
    },
    ids: {
      type: Object
    },
    lineToBar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      this1: this,
      lineColorType: {},
      areaColorType: {},
      lineType: [
        {
          label: "直线",
          value: false
        },
        {
          label: "曲线",
          value: true
        }
      ],
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      showAreaStyle: false,
      showAreaStyleFlag: false,
      labelStyleList: [
        {
          title: "柱状",
          value: "bar"
        },
        {
          title: "折线",
          value: "line"
        }
      ],
      symbolTypeList: [
        {
          label: "圆形",
          value: "circle"
        },
        {
          label: "空心圆形",
          value: "emptyCircle"
        },
        {
          label: "方形",
          value: "rect"
        },
        {
          label: "圆角方形",
          value: "roundRect"
        },
        {
          label: "三角形",
          value: "triangle"
        },
        {
          label: "菱形",
          value: "diamond"
        },
        {
          label: "气球",
          value: "pin"
        },
        {
          label: "箭头",
          value: "arrow"
        },
        {
          label: "图片",
          value: "image"
        }
      ],
      symbolData: "circle"
    }
  },
  created() {
    this.init()
    if (this.symbol && this.symbol.indexOf("image") !== -1) {
      this.symbolData = "image"
    }
  },
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    },
    lineColorType: {
      deep: true,
      handler(val, oldVal) {
        let colorItem, color
        if (val.type === "线性渐变") {
          colorItem = {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: val.startColor || val.color // 0% 处的颜色
              },
              {
                offset: 1,
                color: val.endColor || val.color // 100% 处的颜色
              }
            ]
          }
          color = val.startColor || val.color
        } else {
          colorItem = val.color || val.startColor
          color = val.color || val.startColor
        }
        this.$changeOptionsEV(colorItem, "chartOption.series." + this.index + ".lineStyle.color", false)
        if (!this.hasProperty(colorItem, "chartOption.series." + this.index + ".itemStyle")) {
          this.$changeOptionsEV({}, "chartOption.series." + this.index + ".itemStyle", false)
        }
        this.$changeOptionsEV(colorItem, "chartOption.series." + this.index + ".itemStyle.color", false)
      }
    },
    areaColorType: {
      deep: true,
      handler(val, oldVal) {
        let colorItem
        if (val !== null) {
          // if (JSON.stringify(val.color) !== JSON.stringify(this.seriesSettingItem.areaStyle.color)) {
          if (val.type === "线性渐变") {
            colorItem = {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: val.startColor || val.color // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: val.endColor || val.color // 100% 处的颜色
                }
              ]
            }
          } else {
            colorItem = val.color || val.startColor
          }
          this.$changeOptionsEV(colorItem, "chartOption.series." + this.index + ".areaStyle.color", false)
          // }
        }
      }
    },
    symbolData: {
      handler(val, oloVal) {
        if (val !== "image") {
          this.symbol = val
        } else {
          if(this.symbolImage.indexOf("http") !== -1){
            this.symbol = "image://" + this.symbolImage
          }else{
            let name = window.location.protocol + "//" + window.location.hostname
            this.symbol = "image://" + name + this.symbolImage
          }
        }
      }
    }
  },
  computed: {
    smooth: {
      get() {
        return this.seriesSettingItem.smooth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".smooth", false)
      }
    },
    lineStyleType: {
      get() {
        return this.seriesSettingItem.lineStyle.type
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".lineStyle.type", false)
      }
    },
    lineStyleWidth: {
      get() {
        return this.seriesSettingItem.lineStyle.width
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".lineStyle.width", false)
      }
    },
    symbolSize: {
      get() {
        return this.seriesSettingItem.symbolSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolSize", false)
      }
    },
    symbol: {
      get() {
        return this.seriesSettingItem.symbol
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbol", false)
      }
    },
    symbolImage: {
      get() {
        return this.seriesSettingItem.symbolImage || ""
      },
      set(newVal) {
        if (this.symbolData === "image") {
          if(newVal.indexOf("http") !== -1){
            this.symbol = "image://" + newVal
          }else{
            let name = window.location.protocol + "//" + window.location.hostname
            this.symbol = "image://" + name + newVal
          }
        }
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".symbolImage", false)
      }
    },
    showLabel: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.show")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.show", false)
      }
    },
    labelFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "label.fontFamily", "labelFontFamily", "sans-serif")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontFamily", false)
      }
    },
    labelFontSize: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontSize")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontSize", false)
      }
    },
    labelFontWeight: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.fontWeight")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.fontWeight", false)
      }
    },
    labelFontColor: {
      get() {
        return this.hasProperty(this.seriesSettingItem, "label.color")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.color", false)
      }
    },
    showLabelUnitValue: {
      get() {
        this.checkFormatterValue()
        if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return this.seriesSettingItem.unit
        } else {
          const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
          return this.seriesSettingItem.label.formatter.slice(start, -1)
        }
        // const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
        // return this.seriesSettingItem.label.formatter.slice(start, -1)
      },
      set(newVal) {
        this.$changeOptionsEV(
          `{c}{valueUnit|${newVal}}`,
          "chartOption.series." + this.index + ".label.formatter",
          false
        )
        this.$changeOptionsEV(
          newVal,
          "chartOption.series." + this.index + ".unit",
          false
        )
      }
    },
    showLabelUnit: {
      get() {
        this.checkFormatterValue()
        if (this.seriesSettingItem.hasOwnProperty("unit")) {
          return !!this.seriesSettingItem.unit
        } else {
          const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
          return !!this.seriesSettingItem.label.formatter.slice(start, -1)
        }
        // const start = this.seriesSettingItem.label.formatter.indexOf("|") + 1
        // return !!this.seriesSettingItem.label.formatter.slice(start, -1)
      },
      set(newVal) {
        if (!newVal) {
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            this.$changeOptionsEV(
              "",
              "chartOption.series." + this.index + ".unit",
              false
            )
          }
          this.$changeOptionsEV(`{c}{valueUnit|}`, "chartOption.series." + this.index + ".label.formatter", false)
        } else {
          if (this.seriesSettingItem.hasOwnProperty("unit")) {
            this.$changeOptionsEV(
              " ",
              "chartOption.series." + this.index + ".unit",
              false
            )
          }
          this.$changeOptionsEV(`{c}{valueUnit| }`, "chartOption.series." + this.index + ".label.formatter", false)
        }
      }
    },
    labelUnitValueFontFamily: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontFamily
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontFamily", false)
      }
    },
    labelUnitValueFontSize: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontSize
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontSize", false)
      }
    },
    labelUnitValueFontWeight: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.fontWeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.fontWeight", false)
      }
    },
    labelUnitValueFontColor: {
      get() {
        return this.seriesSettingItem.label.rich.valueUnit.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".label.rich.valueUnit.color", false)
      }
    },
    labelType: {
      get() {
        return this.checkAndSetPrimaryVal(this.seriesSettingItem, "type", "line")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.series." + this.index + ".type", false)
      }
    }
  },
  methods: {
    init() {
      this.initLineColorType()
      this.initAreaColorType()
    },
    // 初始化initLineColorType
    initLineColorType() {
      let result = {}
      const colorTemp = this.seriesSettingItem.lineStyle.color
      if (typeof colorTemp === "string") {
        result = {
          type: "纯色",
          color: colorTemp
        }
      } else if (colorTemp.type === "linear") {
        result = {
          type: "线性渐变",
          startColor: colorTemp.colorStops[0].color,
          endColor: colorTemp.colorStops[1].color
        }
      }
      this.lineColorType = result
    },
    initAreaColorType() {
      let result = {}
      const colorTemp = this.seriesSettingItem.areaStyle.color
      if (colorTemp !== null) {
        if (typeof colorTemp === "string") {
          result = {
            type: "纯色",
            color: colorTemp
          }
        } else if (colorTemp.type === "linear") {
          result = {
            type: "线性渐变",
            startColor: colorTemp.colorStops[0].color,
            endColor: colorTemp.colorStops[1].color
          }
        }
        if (result.color === "rgba(0, 0, 0, 0)") {
          //不显示区域颜色
          this.showAreaStyle = false
        } else {
          this.showAreaStyle = true
          this.areaColorType = result
        }
      } else {
        this.showAreaStyle = false
      }
    },
    // 切换单色多色,每次切换的时候都要去修改chartOption，多色设置会覆盖掉单色设置
    changeLineColorQuantity(colorItemType) {
      if (colorItemType === "纯色") {
        this.$set(this.lineColorType, "color", this.lineColorType.startColor)
      } else {
        this.$set(this.lineColorType, "startColor", this.lineColorType.color)
        this.$set(this.lineColorType, "endColor", this.lineColorType.color)
      }
    },
    // 切换单色多色,每次切换的时候都要去修改chartOption，多色设置会覆盖掉单色设置
    changeAreaColorQuantity(colorItemType) {
      if (colorItemType === "纯色") {
        this.$set(this.areaColorType, "color", this.areaColorType.startColor)
      } else {
        this.$set(this.areaColorType, "startColor", this.areaColorType.color)
        this.$set(this.areaColorType, "endColor", this.areaColorType.color)
      }
    },
    checkFormatterValue() {
      if (!this.seriesSettingItem.label.formatter) {
        this.$changeOptionsEV("{c}{valueUnit| }", "chartOption.series." + this.index + ".label.formatter", false)
        this.$changeOptionsEV(
          {
            valueUnit: {
              fontFamily: "sans-serif",
              color: "rgba(255,255,255,1)",
              fontWeight: "400",
              fontSize: 14
            }
          },
          "chartOption.series." + this.index + ".label.rich",
          false
        )
      }
    },
    changeShowAreaStyleHandle() {
      if (!this.showAreaStyle) {
        this.areaColorType = {
          color: "rgba(0, 71, 255, 1)",
          type: "纯色"
        }
      } else {
        this.areaColorType = {
          color: "rgba(0, 0, 0, 0)",
          type: "纯色"
        }
      }
    },
    // 下拉选择是折线图还是柱状图触发父组件修改数据类型
    typeChange(val) {
      this.$emit("barTypeChangeHandle", val, this.index)
    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.custom-color {
  display: inline-block;
  width: calc(100% - 72px);
  vertical-align: middle;
}
.line-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.line-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.line-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.percent65_ {
  width: calc(100% - 65px);
}
</style>
